/* eslint-disable no-unused-vars */
import { BECOME_OFFLINE, BECOME_ONLINE } from './types'

export const netCoBecomeOnline = () => (dispatch: any) => {
    dispatch({
        type: BECOME_ONLINE,
    })
}

export const netCoBecomeOffline = () => (dispatch: any) => {
    dispatch({
        type: BECOME_OFFLINE,
    })
}
